import {createSlice,PayloadAction} from '@reduxjs/toolkit'

interface SidebarState{
    activeItem:string
}
const initialState:SidebarState={
   activeItem:'/'
}


const sidebarSlice=createSlice({
    name:'sidebar',
    initialState,
    reducers:{
        setActiveItem:(state,action:PayloadAction<string>)=>{
            state.activeItem=action.payload
        }
    }
})

export default sidebarSlice.reducer

export const {setActiveItem}=sidebarSlice.actions